/**
 * Comp `.behind` — collapsed, plain-language log of what the agent did this
 * turn. Closed by default; the user opens it only when they want detail.
 */
export function BehindTheScenes({ items }: { items: string[] }) {
  return (
    <details className="text-[12px] text-faint">
      <summary className="inline-flex cursor-pointer list-none items-center gap-1.5 font-mono text-[11px] text-faint hover:text-muted [&::-webkit-details-marker]:hidden">
        ◦ what I did behind the scenes
      </summary>
      <ul className="mt-1.5 list-disc pl-4 text-[12px] leading-[1.7] text-muted">
        {items.map((item, i) => (
          <li key={`behind-${i}`}>{item}</li>
        ))}
      </ul>
    </details>
  );
}
